import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Card } from 'react-bootstrap';

// Layout
import Header1 from '../layout/header/header2';
import Footer1 from '../layout/footer/footer1';

// Elements
import SolutionSidebar from '../elements/services/solution-sidebar';

// Images
import Banner1 from '../../images/banner/banner1.jpg';
import ServicesPic1 from '../../images/services/service_21.png';
import ServicesPic2 from '../../images/services/pic2.jpg';

class SolutionReservoirStimulation extends Component {

    render(){
        return (
            <>
                <Header1 />
                
                <div className="page-content bg-white">

                    <div className="page-banner ovbl-dark parallax" style={{backgroundImage: "url("+Banner1+")"}}>
                        <div className="container">
                            <div className="page-banner-entry">
                                <h1 className="text-white">Reservoir Stimulation & Activation</h1>
                                <div className="breadcrumb-row">
                                    <ul className="list-inline">
                                        <li><Link to="/"><i className="fa fa-home"></i> Home</Link></li>
                                        <li>Reservoir Stimulation</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="content-block" id="content-area">

                        <div className="section-area section-sp2 bg-fix bg-white">
                            <div className="container about-video">
                                <div className="row">

                                    <div className="col-lg-4 col-md-5 m-b30">
                                         <SolutionSidebar activeService={2} />
                                    </div>

                                    <div className="col-lg-8 col-md-7 service-textarea">

                                        <div className="heading-bx text-left m-b20">
                                            <h3 className="title-head m-b0">Reservoir Stimulation & Activation</h3>
                                            <div className="ttr-separator sepimg"></div>
                                        </div>

                                        <p>We offer innovative reservoir stimulation treatments that enhance production through acidizing, matrix stimulation, nano-enhanced treatments and flow improvement techniques.</p>

                                        <div className="row ">
                                            <div className="col-md-12 m-b15">
                                                <img src={ServicesPic1} className="radius-sm imghight" alt=""/>
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Our Solutions</h4>
                                        <p>Our stimulation programs restore formation permeability, dissolve near-wellbore damage and boost hydrocarbon flow.</p>

                                        <div className="row">
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Matrix acidizing</li>
                                                    <li>Formation stimulation</li>
                                                    <li>Nano-enhanced flow activators</li>
                                                </ul>
                                            </div>
                                            <div className="col-lg-6">
                                                <ul className="list-check">
                                                    <li>Skin reduction</li>
                                                    <li>Well productivity improvement</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <h4 className="title m-b5">Key Benefits</h4>
                                        <p>Improves reservoir permeability and significantly boosts well productivity.</p>

                                        <div className="row">
                                            <div className="col-xl-7 col-lg-12">
                                                <ul className="service-list-circle">
                                                    <li><i className="flaticon-maintenance"></i>Effective removal of formation damage.</li>
                                                    <li><i className="flaticon-light-bolt"></i>Enhanced and sustained production flow.</li>
                                                    <li><i className="flaticon-mask"></i>High-efficiency chemical and nano-based treatments.</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <Accordion className="ttr-accordion gray" defaultActiveKey="0">
                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="0">
                                                    <Link to="#">Acidizing Treatments</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="0">
                                                    <Card.Body>
                                                        Targeted treatments to remove scale, carbonates, and near-wellbore damage.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="1">
                                                    <Link to="#">Nano-Enhanced Stimulation</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="1">
                                                    <Card.Body>
                                                        Nanotechnology solutions designed to improve reservoir permeability and flow.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>

                                            <Card>
                                                <Accordion.Toggle as={Card.Header} eventKey="2">
                                                    <Link to="#">Productivity Boosting Programs</Link>
                                                </Accordion.Toggle>
                                                <Accordion.Collapse eventKey="2">
                                                    <Card.Body>
                                                        Long-term stimulation programs for continuous production optimization.
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>

                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <Footer1 />
            </>
        );
    }
}

export default SolutionReservoirStimulation;
